import { useEffect, useState, useCallback } from "react";
import useSize from "../../useSize/useSize";
import moment from "moment";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";
import Filter from "./Filter/Filter";
import TotalCard from "./TotalCard/TotalCard";
import Loading from "../../Loading/Loading";
import NotFound from "../../NotFound/NotFound";
import Menu from "./Menu/Menu";
import LedgerCard from "./LedgerCard";

const backend = await new Backend().init();

export default function Ledger({ user_id }) {
  const windowSize = useSize();

  const [loading, setLoading] = useState(false);
  const [ledger, setLedger] = useState([]);

  const [deposit, setDeposit] = useState(0);
  const [withdraw, setWithdraw] = useState(0);
  const [deposit_wallet, setDepositWallet] = useState(0);
  const [withdraw_wallet, setWithdrawWallet] = useState(0);
  const [credit, setCredit] = useState(0);
  const [pl, setPl] = useState(0);
  const [nse_cash, setNseCash] = useState(0);
  /** ----------------------------------------------------
   * 🔵 COMMON LEDGER FETCHER
   * initial = true → do NOT send start/end
   ---------------------------------------------------- */
  const fetchLedger = useCallback(
    async (start, end, initial = false) => {
      setLoading(true);

      const payload = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        ledger_id: user_id,
      };

      // ⛔ Initial load → do not send start/end
      if (!initial) {
        payload.start = start;
        payload.end = end;
      }

      try {
        const r = await backend.load_ledger(payload);
        setLoading(false);

        if (r.error === "False") {
          setLedger(r.ledger);
          setWithdraw(r.withdraw);
          setDeposit(r.deposit);

          setWithdrawWallet(r.withdraw_wallet);
          setDepositWallet(r.deposit_wallet);

          setCredit(r.credit);
          setPl(r.net_pl);
          setNseCash(r.nse_cash);
        } else {
          toast.error(r.message || "Something went wrong");
        }
      } catch (err) {
        setLoading(false);
        toast.error("Server error while loading ledger");
      }
    },
    [user_id]
  );

  /** ----------------------------------------------------
   * 🔵 LOAD FIRST TIME (NO DATE)
   ---------------------------------------------------- */
  useEffect(() => {
    fetchLedger(null, null, true);
  }, [fetchLedger]);

  /** ----------------------------------------------------
   * 🔵 LOAD ON DATE FILTER (WITH DATE)
   ---------------------------------------------------- */
  const loadLedgerDate = (start, end) => {
    fetchLedger(start, end, false);
  };

  /** ----------------------------------------------------
   * 🔵 HEIGHT VALUES
   ---------------------------------------------------- */
  const containerHeight = windowSize[1] - 170;
  const listHeight = windowSize[1] - 330;

  return (
    <div style={{ width: windowSize[0] - 100, height: containerHeight }}>
      <Filter ledger={loadLedgerDate} />

      <TotalCard
        nse_cash={nse_cash}
        pl={pl}
        deposit_wallet={deposit_wallet}
        withdraw_wallet={withdraw_wallet}
        deposit={deposit}
        credit={credit}
        withdraw={withdraw}
      />

      <Menu />

      <div
        style={{
          height: listHeight,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={listHeight} />
          </div>
        ) : ledger.length > 0 ? (
          <div style={{ height: listHeight, overflowY: "scroll" }}>
            {ledger.map((item) => (
              <LedgerCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={listHeight}
            title="Nothing here"
            subtext="No Ledger Found."
          />
        )}
      </div>
    </div>
  );
}
